import React from "react";
import img2 from "./logo.png";
const HeaderImage = () => {
  return (
    <img
      src={img2}
      id="S"
      alt=""
      style={{
        marginTop: "5px",
        height: window.innerWidth < 768 && "auto",
      }}
    />
  );
};

export default HeaderImage;
